import { IProfileData } from "container/profile-admin/profile";
import { API, Http } from "services/http/http";
import { paramsObjectToQueryString } from "utils/generic-utils";

export const updateProfile = (payload: IProfileData) => Http.put("/user/profile", payload);

export const changePassword = (payload) =>
   Http.patch(
      "/user/reset-password?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IkswcU1DUF82dUdHY3kwdUF2WXY4ayIsInR5cGUiOiJwYXJlbnQiLCJlbWFpbCI6ImRvZGFuaWVsb2x1d2FkYXJlKzc4QGdtYWlsLmNvbSIsImlhdCI6MTYzMDgwMTYyMywiZXhwIjoxNjMwODA1MjIzfQ.gAm3hOj5-oQ9m3z_7EG7DXqvbddDdDSTVcY4VA_h9MU",
      { password: payload.password }
   );

export const fetchParents = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/admin/user/parent${paramsObjectToQueryString(payload)}`,
   });

export const fetchPartners = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/admin/user/partner${paramsObjectToQueryString(payload)}`,
   });

export const fetchAdmins = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/admin/user/school-admin${paramsObjectToQueryString(payload)}`,
   });

export const searchParents = (val: string) => Http.get(`/admin/user/parent?search=${val}`);

export const searchPartners = (val: string) => Http.get(`/admin/user/partner?search=${val}`);

export const searchAdmins = (val: string) => Http.get(`/admin/user/school-admin?search=${val}`);

export const deleteUser = (id: any) => Http.delete(`/admin/user/${id}`);
